import React from 'react';
import { ShoppingBag } from 'lucide-react';
import OrderReviewItem from './OrderReviewItem';

const OrderReviewList = ({ items }) => {
  const totalItemsCount = items ? items.reduce((acc, item) => acc + item.qty, 0) : 0;

  return (
    <div className="checkout-card order-review-section">
      <h3 className="checkout-card-title">
        <ShoppingBag size={18} color="#ff7a00" />
        <span>Order Review ({items.length} {items.length === 1 ? 'Product' : 'Products'}, {totalItemsCount} Pcs)</span>
      </h3>

      <div className="order-review-list-container">
        {items && items.map((item) => (
          <OrderReviewItem
            key={item.productId}
            item={item}
          />
        ))}
      </div>
    </div>
  );
};

export default OrderReviewList;
